import { Avatar, Card, CardContent, Typography, Link } from '@mui/material'
import { Star } from '@mui/icons-material'
import { UserBookReview } from '../../types'
import { translations } from '../../translations';

interface RecentActivityProps {
  reviews: UserBookReview[]
  isRtl: boolean
}

export function RecentActivity({ reviews, isRtl }: RecentActivityProps) {
  const t = isRtl ? translations.ku : translations.en;

  return (
    <Card dir={isRtl ? 'rtl' : 'ltr'}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t.recentActivity}
        </Typography>
        {reviews.length === 0 && (
          <Typography variant="body1" color="text.secondary">
            {t.noRecentActivity}
          </Typography>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {reviews.map((review) => (
            <div key={review.id} style={{ display: 'flex', gap: '16px', direction: isRtl ? 'rtl' : 'ltr' }}>
              <Link
                component="button"
                onClick={() => window.location.href = `/books/${review.book_id}`}
                sx={{ border: 'none', background: 'none', padding: 0 }}
              >
                <Avatar
                  variant="square"
                  src={review.book_cover}
                  alt={review.book_title}
                  sx={{ width: 64, height: 80, cursor: 'pointer' }}
                />
              </Link>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', direction: isRtl ? 'rtl' : 'ltr' }}>
                <Link
                  component="button"
                  onClick={() => window.location.href = `/books/${review.book_id}`}
                  sx={{ border: 'none', background: 'none', padding: 0, textAlign: 'start' }}
                >
                  <Typography variant="subtitle1" fontWeight="medium" sx={{ cursor: 'pointer' }}>
                    {review.book_title}
                  </Typography>
                </Link>
                <div style={{ display: 'flex', direction: isRtl ? 'rtl' : 'ltr' }}>
                  {Array.from({ length: review.rating }).map((_, i) => (
                    <Star key={i} sx={{ color: 'primary.main', fontSize: 16 }} />
                  ))}
                </div>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    direction: isRtl ? 'rtl' : 'ltr'
                  }}
                >
                  {review.review}
                </Typography>
                <Typography variant="caption" color="text.secondary" dir={isRtl ? 'rtl' : 'ltr'}>
                  {review.date}
                </Typography>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
